import { BottomSheet } from '@protector/new-ui';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { COLLAPSED_SHEET_HEIGHT_PX } from '../hooks/use-cluster-popup.constants';

interface MapDetailSheetProps {
  fieldOpen: boolean;
  clusterOpen: boolean;
  fieldContent: ReactNode;
  clusterContent: ReactNode;
  onCloseField: () => void;
  onCloseCluster: () => void;
}

export const MapDetailSheet = ({
  fieldOpen,
  clusterOpen,
  fieldContent,
  clusterContent,
  onCloseField,
  onCloseCluster
}: MapDetailSheetProps) => {
  const [t] = useTranslation();

  return (
    <BottomSheet
      open={fieldOpen || clusterOpen}
      ariaLabel={t('general.details')}
      body={fieldOpen ? fieldContent : clusterContent}
      onClose={fieldOpen ? onCloseField : onCloseCluster}
      showCloseButton={false}
      fullBleed
      collapsedHeightPx={COLLAPSED_SHEET_HEIGHT_PX}
      initialSnap={0}
    />
  );
};
